import React from "react";
import SolutionsHero from "./SolutionsHero";
import SolutionsBlocks from "./SolutionsBlocks";
import SolutionsScrutiny from "./SolutionsScrutiny";
import TrustStrip from "../shared/TrustStrip";
import FAQSection from "../Pricing/FAQSection";
import PageLayout from "../PageLayout/PageLayout";
import { SOLUTIONS_FAQS } from "./solutionsData";
import "./SolutionsPage.css";

export default function UseCasesPage() {
  return (
    <div className="solutions-page">
      <PageLayout fullBleed>
        <SolutionsHero />
        <TrustStrip />
        <SolutionsBlocks />
        <SolutionsScrutiny />
        <FAQSection variant="home" faqs={SOLUTIONS_FAQS} />
      </PageLayout>
    </div>
  );
}
